import * as React from 'react';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var ExpansionPanelContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ExpansionPanelContext.displayName = 'ExpansionPanelContext';
}

export default ExpansionPanelContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ExpansionPanel/ExpansionPanelContext.js
// module id = 672
// module chunks = 0